import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Achievements from './Achievements';
import HeroSection from './HeroSection';
import Card from './Card';
import Owl from './Owl';
import Services from './Services';
import Technologies from './Technologies';
import { Helmet } from 'react-helmet';

const BusinessIntel = (props) => {
    const { slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Business Intelligence Development Company – Infograins</title>
                <meta name="description" content="Infograins delivers a broad spectrum of business intelligence services designed to enhance your operational and financial performance." />
            </Helmet>
            <HeroSection />
            <Achievements />
            <Services />
            <Technologies />
            <Owl />
            <Card />
        </>
    )
}

export default BusinessIntel